import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../Sidebar/Sidebar.scss";
import LogoIcon from "../../assets/images/white_locshark_1.png";
import userAvatar from "../../assets/images/user1.png";
import Document from "../../assets/images/Document.png";
import Full_Screen from "../../assets/images/Full-Screen.png";
import Pinpoint from "../../assets/images/Pinpoint.png";
import { USER_MANAGEMENT } from "../../utils/const";
import usePlanPermissions from "../../hook/usePlanPermissions";
import { getProfileImage } from "../../utils/common";
import useApi from "../../hook/useAPI";
import { useContextValue } from "../../context/LoaderContext";
import PushNotificationModal from "./PushNotificationModal";
import UserNoticesBar from "../UserNotices/UserNoticesBar";
import { logout } from "../../utils/auth";
import { openStripeCustomerPortal } from "../../utils/stripePortal";
import { toast } from "react-toastify";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userDetails, activePlan } = useContextValue();
  const [show,setShow ] = useState(false);
  const [inpEvent, setInpEvent] = useState(null);
  const isActive = (path) => location.pathname === path;
  const role = localStorage.getItem('UserRole')
  const once_expires_in  = localStorage.getItem('1nce_expires_in')
  const {
    canAccessTrips: hasTrips,
    canAccessZones: hasZones,
    canAccessReports: hasReports,
  } = usePlanPermissions();
  const [photoURL, setPhotoURL] = useState()
  const { getData, postData } = useApi();
  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = async (event) => {
    if(inpEvent){
     
      await getData(USER_MANAGEMENT.PUSH_NOTIFICATION);
      setShow(false);
      setIsChecked(!inpEvent.target.checked);
      toast.success(`You have successfully opted ${!inpEvent.target.checked === false ? 'out'  : 'in' } to SMS and email notifications`);
    }
    
  };


  useEffect(() => {
    if (userDetails?.push_notification !== undefined) {
      setIsChecked(userDetails.push_notification);
    }
  }, [userDetails?.push_notification]);

  const onceAuthentication = async () => {
    // const res = await getData(`${AUTH?.ONCE_AUTHENTICATE}`);
    //     localStorage.setItem('1nce_access_token', res?.access_token);
    //     localStorage.setItem("1nce_expires_in" , res?.expires_in)

  }

  useEffect(() => {
    const intervalMs = Number(once_expires_in) * 1000;
    if (!Number.isFinite(intervalMs) || intervalMs <= 0) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      onceAuthentication();
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [once_expires_in]);


  useEffect(() => {
    if (userDetails !== null) {
      getProfileImage(userDetails?.profileFileName, setPhotoURL)
    }
  }, [userDetails])

  const saveEvent = (event) => {
    setInpEvent(event);
    setShow(true);
  };

  const handleManageBilling = async () => {
    try {
      await openStripeCustomerPortal(postData, '/main/account', activePlan);
    } catch (error) {
      toast.error('Unable to open billing portal.');
      navigate('/main/account#plans');
    }
  };

  const handleLogOut = () => {
    logout(navigate);
  };


  return (
    <>
      <div className="sidebar_main">
        <div
          className="offcanvas offcanvas-start"
          tab-index="-1"
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
        >
          <div className="offcanvas_header">
            <div className="header_logo">
              <img src={LogoIcon} className="img-fluid" alt="logo" />
            </div>
          </div>

          <div className="offcanvas-body">
            <div className="inner_sidebar">
              <div className="menu_list" id="sidebar">
                {Number(role) === 1 ?
                  <ul>
                    <li className="nav-item">
                      <Link className={`ato ${isActive("/main/user") ? "active" : ""}`} to="/main/user" data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 14.062V20H13V14.062C16.946 14.554 20 17.92 20 22H4C4.00003 20.0514 4.71119 18.1698 6 16.7083C7.28882 15.2467 9.0667 14.3058 11 14.062ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <span>User Management </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className={`ato ${isActive("/main/subscription") ? "active" : ""}`} to="/main/subscription"   data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1_318)">
                              <path
                                d="M14 2C15.8299 1.99913 17.6049 2.62567 19.0288 3.77513C20.4527 4.92458 21.4395 6.52748 21.8246 8.31647C22.2097 10.1055 21.9699 11.9724 21.145 13.6059C20.3202 15.2395 18.9602 16.5408 17.292 17.293C16.7587 18.4719 15.9475 19.5039 14.9278 20.3004C13.9082 21.097 12.7105 21.6343 11.4376 21.8663C10.1647 22.0984 8.85446 22.0182 7.61933 21.6327C6.3842 21.2472 5.261 20.5678 4.34608 19.6529C3.43115 18.738 2.7518 17.6148 2.36628 16.3796C1.98076 15.1445 1.90058 13.8343 2.13262 12.5614C2.36466 11.2884 2.90199 10.0908 3.69854 9.07114C4.49508 8.05148 5.52705 7.24024 6.70596 6.707C7.34011 5.30389 8.36555 4.1135 9.65931 3.27861C10.9531 2.44371 12.4602 1.99976 14 2ZM11 9H8.99996V10C8.35008 9.99842 7.72512 10.25 7.25755 10.7013C6.78998 11.1527 6.51655 11.7684 6.49523 12.418C6.4739 13.0675 6.70635 13.6998 7.14331 14.1809C7.58026 14.6619 8.18737 14.9539 8.83596 14.995L8.99996 15H11L11.09 15.008C11.2052 15.0289 11.3095 15.0896 11.3846 15.1795C11.4597 15.2694 11.5009 15.3828 11.5009 15.5C11.5009 15.6172 11.4597 15.7306 11.3846 15.8205C11.3095 15.9104 11.2052 15.9711 11.09 15.992L11 16H6.99996V18H8.99996V19H11V18C11.6498 18.0016 12.2748 17.75 12.7424 17.2987C13.2099 16.8473 13.4834 16.2316 13.5047 15.582C13.526 14.9325 13.2936 14.3002 12.8566 13.8191C12.4197 13.3381 11.8126 13.0461 11.164 13.005L11 13H8.99996L8.90996 12.992C8.79468 12.9711 8.69039 12.9104 8.61529 12.8205C8.54019 12.7306 8.49905 12.6172 8.49905 12.5C8.49905 12.3828 8.54019 12.2694 8.61529 12.1795C8.69039 12.0896 8.79468 12.0289 8.90996 12.008L8.99996 12H13V10H11V9ZM14 4C13.1526 3.99901 12.3148 4.17794 11.5418 4.52496C10.7688 4.87198 10.0783 5.37918 9.51596 6.013C10.6462 5.94439 11.7782 6.1165 12.837 6.51795C13.8958 6.9194 14.8573 7.54105 15.6579 8.34178C16.4586 9.14252 17.0801 10.1041 17.4814 11.1629C17.8827 12.2218 18.0547 13.3537 17.986 14.484C18.8952 13.6756 19.5372 12.6099 19.8268 11.4283C20.1164 10.2467 20.04 9.00492 19.6076 7.86772C19.1752 6.73053 18.4074 5.75164 17.4059 5.06088C16.4044 4.37013 15.2166 4.00014 14 4Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_318">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                        <span>Subscription Management </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className={`ato ${isActive("/main/time-tracking") ? "active" : ""}`} to="/main/time-tracking" data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="2" />
                            <path d="M12 7V12H16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        </div>
                        <span>Time Tracking</span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className={`ato ${isActive("/main/health") ? "active" : ""}`} to="/main/health" data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <span>System Health</span>
                      </Link>
                    </li>
                  </ul> :
                  <></>}
                {Number(role) === 2 ?
                  <ul className="menu_list_main">
                    <li className="nav-item">
                      <Link className={`ato ${isActive("/main/home") ? "active" : ""}`} to="/main/home"   data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width="7" height="10" rx="1" fill="white" />
                            <rect
                              y="11"
                              width="7"
                              height="5"
                              rx="1"
                              fill="white"
                            />
                            <rect
                              x="16"
                              y="16"
                              width="7"
                              height="10"
                              rx="1"
                              transform="rotate(-180 16 16)"
                              fill="white"
                            />
                            <rect
                              x="16"
                              y="5"
                              width="7"
                              height="5"
                              rx="1"
                              transform="rotate(-180 16 5)"
                              fill="white"
                            />
                          </svg>
                        </div>
                        <span>Home </span>
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className={`ato ${isActive("/main/time-tracking") ? "active" : ""}`} to="/main/time-tracking" data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="9" stroke="white" strokeWidth="2" />
                            <path d="M12 7V12H16" stroke="white" strokeWidth="2" strokeLinecap="round" />
                          </svg>
                        </div>
                        <span>Time Tracking</span>
                      </Link>
                    </li>
                    {hasTrips && <li className="nav-item">
                      <Link className={`ato ${isActive("/main/trips") ? "active" : ""}`} to="/main/trips"   data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <img src={Pinpoint} alt="" />
                        </div>
                        <span>Trips </span>
                      </Link>
                    </li>}
                    {hasZones && <li className="nav-item">
                      <Link className={`ato ${isActive("/main/zones") ? "active" : ""}`} to="/main/zones"   data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <img src={Full_Screen} alt="" />
                        </div>
                        <span>Zones </span>
                      </Link>
                    </li>}
                    {hasReports && <li className="nav-item">
                      <Link className={`ato ${isActive("/main/reports") ? "active" : ""}`} to="/main/reports"   data-bs-dismiss="offcanvas">
                        <div className="sidebar_icon">
                          <img src={Document} alt="" />
                        </div>
                        <span>Reports </span>
                      </Link>
                    </li>}
                  </ul>
                  : <></>}
              </div>
            </div>

            <div className="sidebar-footer">
              <Link
                className={`sidebar-user-link ${isActive("/main/account") ? "active" : ""}`}
                to="/main/account"
                data-bs-dismiss="offcanvas"
              >
                <img
                  src={photoURL ? photoURL : userAvatar}
                  className="sidebar-user-avatar"
                  alt=""
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = userAvatar;
                  }}
                />
                <span className="sidebar-user-copy">
                  <span className="sidebar-user-name">
                    {userDetails?.firstname} {userDetails?.lastname}
                  </span>
                  <span className="sidebar-user-meta">Account settings</span>
                </span>
              </Link>
              {Number(role) !== 1 && (
                <div className="sidebar-footer-notices">
                  <UserNoticesBar
                    variant="sidebar"
                    activePlan={activePlan}
                    limit={1}
                    onUpgrade={() => navigate('/main/account#plans')}
                    onManageBilling={handleManageBilling}
                  />
                </div>
              )}
              <div className="sidebar-footer-actions">
                <div className="sidebar-footer-row">
                  <span className="sidebar-footer-label">Push notifications</span>
                  <div className="custome-switch">
                    <label className="switch">
                      <input type="checkbox" checked={isChecked} onChange={saveEvent} />
                      <span className="slider round" />
                    </label>
                  </div>
                </div>
                <button
                  type="button"
                  className="sidebar-logout-btn"
                  data-bs-dismiss="offcanvas"
                  onClick={handleLogOut}
                >
                  Log out
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <PushNotificationModal show={show} isChecked={isChecked} handleClose={()=>{setShow(false);}} handleConfirm={handleCheckboxChange}></PushNotificationModal>
      
    </>
  );
};

export default Sidebar;
